var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isGolfService)?_c('img',{staticClass:"logo-img",attrs:{"src":require("@/assets/golf/spotv-now-golf.png")}}):_c('img',{staticClass:"logo-img",attrs:{"src":require("@/assets/logo-spotvnow-l.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }